import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-center" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "w-full mt-2" }
const _hoisted_5 = {
  key: 0,
  class: "text-red-400 text-sm mt-2"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "ИИН не прошел проверку СБ!", -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  class: "text-red-400 text-sm mt-2"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Отказано службой безопасности", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, "Обратитесь в службу безопасности", -1)
const _hoisted_11 = {
  key: 2,
  class: "text-red-400 text-sm mt-2"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", null, "Физ. лицо не прошел проверку службы безопасности", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", null, "Обратитесь в службу безопасности", -1)
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = {
  key: 0,
  aclass: "text-sm text-gray-400"
}
const _hoisted_16 = { class: "w-full mt-2" }
const _hoisted_17 = {
  key: 0,
  class: "text-red-400 text-sm mt-2"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Отказано службой безопасности", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", null, "Обратитесь в службу безопасности", -1)
const _hoisted_20 = {
  key: 1,
  class: "text-red-400 text-sm mt-2"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", null, "Авто не прошло проверку службы безопасности", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", null, "Обратитесь в службу безопасности", -1)
const _hoisted_23 = [
  _hoisted_21,
  _hoisted_22
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_cheap = _resolveComponent("cheap")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_radio_group = _resolveComponent("radio-group")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    class: "large",
    scrollable: "",
    title: "Заполните данные о перевозчике",
    loading: _ctx.state.is_loading || _ctx.sb_state_iin.is_loading || _ctx.sb_state_car.is_loading,
    onCancel: _ctx.emitCancel,
    onConfirm: _ctx.emitSubmitted
  }, {
    default: _withCtx(() => [
      _createVNode(_component_the_select, {
        "is-invalid": _ctx.state_form$.carrier_id.$error,
        "validation-errors": _ctx.state_form$.carrier_id.$errors,
        value: _ctx.carrier_state.carrier_id,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.carrier_state.carrier_id) = $event)),
        placeholder: "Перевозчик",
        label: "name",
        "search-by": "name",
        "select-by": "id",
        options: _ctx.data_state.carriers.list,
        loading: _ctx.data_state.carriers.is_loading,
        failed: _ctx.data_state.carriers.is_failed,
        "error-text": "При получении списка перевозчиков произошла ошибка",
        "infinite-scroll": "",
        onRefresh: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadCarriers(_ctx.data_state.carriers.pagination.current_page))),
        onLoadmore: _cache[2] || (_cache[2] = ($event: any) => (_ctx.loadMoreCarriers(_ctx.data_state.carriers.pagination.current_page + 1))),
        onSearch: _ctx.searchCarriers,
        onOptionBySearch: _ctx.unshiftFindedCarrier,
        onChange: _ctx.onCarrierChange
      }, {
        "selected-option": _withCtx(({ option }) => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("span", null, _toDisplayString(option.name), 1),
            _createVNode(_component_cheap, {
              class: _normalizeClass(_ctx.getNdsClass(option.is_nds))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.getNdsText(option.is_nds)), 1)
              ]),
              _: 2
            }, 1032, ["class"])
          ])
        ]),
        option: _withCtx(({ option }) => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", null, _toDisplayString(option.name), 1),
            _createVNode(_component_cheap, {
              class: _normalizeClass(_ctx.getNdsClass(option.is_nds))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.getNdsText(option.is_nds)), 1)
              ]),
              _: 2
            }, 1032, ["class"])
          ])
        ]),
        _: 1
      }, 8, ["is-invalid", "validation-errors", "value", "options", "loading", "failed", "onSearch", "onOptionBySearch", "onChange"]),
      (_ctx.isRenderingInputs)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_the_select, {
              class: "mt-3",
              value: _ctx.carrier_state.driver_id,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.carrier_state.driver_id) = $event)),
              placeholder: "Водитель",
              label: "fullName",
              "search-by": "fullName",
              "select-by": "id",
              options: _ctx.data_state.couriers.list,
              loading: _ctx.data_state.couriers.is_loading,
              failed: _ctx.data_state.couriers.is_failed,
              "error-text": "При получении списка водителей произошла ошибка",
              "infinite-scroll": "",
              onRefresh: _cache[4] || (_cache[4] = ($event: any) => (_ctx.loadCouriers(_ctx.data_state.couriers.pagination.current_page))),
              onLoadmore: _cache[5] || (_cache[5] = ($event: any) => (_ctx.loadMoreCouriers(_ctx.data_state.couriers.pagination.current_page + 1))),
              onSearch: _ctx.searchCouriers,
              onOptionBySearch: _ctx.unshiftFindedCourier,
              onChange: _ctx.onCourierSelect,
              disabled: !_ctx.carrier_state.carrier_id
            }, null, 8, ["value", "options", "loading", "failed", "onSearch", "onOptionBySearch", "onChange", "disabled"]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_the_input, {
                class: "w-full",
                placeholder: "ИИН",
                value: _ctx.carrier_state.driver_iin,
                "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.carrier_state.driver_iin) = $event)),
                "is-invalid": _ctx.state_form$.driver_iin.$error,
                "validation-errors": _ctx.state_form$.driver_iin.$errors,
                disabled: _ctx.carrier_state.driver_id
              }, null, 8, ["value", "is-invalid", "validation-errors", "disabled"]),
              (_ctx.isNotFoundIIN)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
                : _createCommentVNode("", true),
              (_ctx.isRejectedIIN)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("p", null, [
                      _hoisted_9,
                      _createTextVNode(" (" + _toDisplayString(_ctx.sb_state_iin.reject_comment) + ") ", 1)
                    ]),
                    _hoisted_10
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isNotCheckedIIN)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_14))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_the_input, {
              class: "w-full mt-2",
              placeholder: "ФИО водителя",
              value: _ctx.carrier_state.driver_name,
              "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.carrier_state.driver_name) = $event)),
              disabled: _ctx.carrier_state.driver_id
            }, null, 8, ["value", "disabled"]),
            _createVNode(_component_the_input, {
              class: "w-full mt-2",
              placeholder: "Номер телефона водителя",
              value: _ctx.carrier_state.driver_phone,
              "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.carrier_state.driver_phone) = $event))
            }, null, 8, ["value"]),
            _createVNode(_component_the_select, {
              class: "mt-3",
              value: _ctx.carrier_state.car_id,
              "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.carrier_state.car_id) = $event)),
              placeholder: "Машина",
              "is-invalid": _ctx.state_form$.car_id.$error,
              "validation-errors": _ctx.state_form$.car_id.$errors,
              loading: _ctx.data_state.cars.is_loading,
              options: _ctx.data_state.cars.list,
              failed: _ctx.data_state.cars.is_failed,
              "error-text": "При получении списка машин произошла ошибка",
              "search-by": "number",
              "select-by": "id",
              "infinite-scroll": "",
              onRefresh: _cache[10] || (_cache[10] = ($event: any) => (_ctx.loadCars(_ctx.data_state.cars.pagination.current_page))),
              onLoadmore: _cache[11] || (_cache[11] = ($event: any) => (_ctx.loadMoreCars(_ctx.data_state.cars.pagination.current_page + 1))),
              onSearch: _ctx.searchCars,
              onOptionBySearch: _ctx.unshiftFindedCars,
              onChange: _ctx.onCarSelect
            }, {
              "selected-option": _withCtx(({ option }) => [
                (option.company)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(option.model) + ", " + _toDisplayString(option.number) + " (" + _toDisplayString(option.company.name) + ") ", 1)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(option.model) + ", " + _toDisplayString(option.number), 1)
                    ], 64))
              ]),
              option: _withCtx(({ option }) => [
                _createElementVNode("div", null, [
                  _createElementVNode("p", null, _toDisplayString(option.model) + ", " + _toDisplayString(option.number), 1),
                  (option.company)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(option.company.name), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["value", "is-invalid", "validation-errors", "loading", "options", "failed", "onSearch", "onOptionBySearch", "onChange"]),
            _createVNode(_component_the_input, {
              class: "w-full mt-2",
              placeholder: "Марка авто",
              value: _ctx.carrier_state.car_brand,
              "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.carrier_state.car_brand) = $event)),
              "is-invalid": _ctx.state_form$.car_brand.$error,
              "validation-errors": _ctx.state_form$.car_brand.$errors,
              disabled: _ctx.carrier_state.car_id
            }, null, 8, ["value", "is-invalid", "validation-errors", "disabled"]),
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_the_input, {
                class: "w-full",
                placeholder: "Гос. номер",
                value: _ctx.carrier_state.car_number,
                "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.carrier_state.car_number) = $event)),
                "is-invalid": _ctx.state_form$.car_number.$error,
                "validation-errors": _ctx.state_form$.car_number.$errors,
                disabled: _ctx.carrier_state.car_id
              }, null, 8, ["value", "is-invalid", "validation-errors", "disabled"]),
              (_ctx.isRejectedCar)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _createElementVNode("p", null, [
                      _hoisted_18,
                      _createTextVNode(" (" + _toDisplayString(_ctx.sb_state_car.reject_comment) + ") ", 1)
                    ]),
                    _hoisted_19
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isNotCheckedCar)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, _hoisted_23))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_the_input, {
              class: "w-full mt-2",
              placeholder: "Гос. номер прицепа",
              value: _ctx.carrier_state.trailer_license_number,
              "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.carrier_state.trailer_license_number) = $event))
            }, null, 8, ["value"]),
            _createVNode(_component_the_input, {
              class: "w-full mt-2",
              placeholder: "Номер удостоверения водителя",
              value: _ctx.carrier_state.driver_id_number,
              "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.carrier_state.driver_id_number) = $event))
            }, null, 8, ["value"]),
            _createVNode(_component_the_input, {
              class: "mt-2",
              type: "date",
              placeholder: "Дата выдачи удостоверения личности",
              value: _ctx.carrier_state.driver_id_date,
              "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.carrier_state.driver_id_date) = $event))
            }, null, 8, ["value"]),
            _createVNode(_component_the_input, {
              class: "w-full mt-2",
              placeholder: "Номер водительских прав",
              value: _ctx.carrier_state.driver_license_number,
              "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.carrier_state.driver_license_number) = $event))
            }, null, 8, ["value"]),
            _createVNode(_component_the_input, {
              class: "mt-2",
              type: "date",
              placeholder: "Дата выдачи водительских прав водителя",
              value: _ctx.carrier_state.driver_license_date,
              "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.carrier_state.driver_license_date) = $event))
            }, null, 8, ["value"]),
            _createVNode(_component_the_input, {
              class: "w-full",
              placeholder: _ctx.getPlaceholder,
              value: _ctx.carrier_state.cost_price,
              "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.carrier_state.cost_price) = $event)),
              "is-invalid": _ctx.state_form$.cost_price.$error,
              "validation-errors": _ctx.state_form$.cost_price.$errors
            }, null, 8, ["placeholder", "value", "is-invalid", "validation-errors"]),
            _createVNode(_component_radio_group, {
              name: "shipment_type",
              value: _ctx.carrier_state.payment_rate_type_id,
              "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.carrier_state.payment_rate_type_id) = $event)),
              options: _ctx.FTL_PAYMENT_RATE_TYPES,
              class: "small my-3"
            }, null, 8, ["value", "options"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["loading", "onCancel", "onConfirm"]))
}